// @flow
export const actionsId = {
  Search: "iotIT01weH6iAM5eWdyG",
  ProductView: "hF5j2o9i0ybvBLIVHY96",
  ShopView: "R8DQrfpGAVifhyOt3EbG",
  SellerContactProduct: "eYMPqE35F8swZn311Ahr",
  SellerContactShop: "IhUgEFuuh1gyH4nzRL5s",
  ContactSupport: "AMuDqhNXvGyIBYj4Agt5",
};
